import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import { AppraisalDataModel, AppraisalModel } from '../../models/appraisal.model';

import { map } from 'rxjs/operators';
import { BuildRequestModel } from '../../containers/appraisal/models/buildRequest.model';
import { ChecksAppraisalModel } from '../../containers/appraisal/models/checksAppraisal.model';
import { ConfirmPaymentModel } from '../../containers/appraisal/models/confirmPayment.model';

@Injectable()
export class AppraisalService {
  constructor(private commonService: CommonService) {}

  public getAppraisal(): Observable<AppraisalModel> {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/appraisal`;
    // const url = `assets/mocks/appraisal.json`;
    return this.commonService.getVerb(url).pipe(
      map((response: AppraisalModel) => {
        response.mortgagesAppraisalData.cadastralData.forEach((e) => {
          if (e.propertyRegistry == null) {
            e.propertyRegistry = {
              registry: '',
              registryNumber: '',
              farmNumber: '',
              volume: '',
              book: '',
              folio: '',
            };
          }
        });
        return response;
      }),
    );
  }

  public saveAppraisal(appraisal: AppraisalDataModel, showLoader = true) {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/appraisal`;
    return this.commonService.postVerb(url, appraisal, showLoader);
  }

  public setChecks(data: ChecksAppraisalModel) {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/appraisal/checks`;
    return this.commonService.postVerb(url, data);
  }

  public buildRequestTPV(body: ConfirmPaymentModel): Observable<BuildRequestModel> {
    const url = `${environment.apiBase}/morttpv/${environment.api_version.tpv}/mortgage/buildRequest`;
    return this.commonService.postVerb(url, body);
  }
}
